
import { createContext } from "react";



export const LangContext = createContext(
  localStorage.getItem("lang") ?? window.navigator.language.slice(0, 2)
);